/**
 * /tenants/$slug/posture/compliance/controls/$catalogId — route shim.
 *
 * Prefetches the control detail then mounts the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { complianceDetailSearchSchema } from "@/features/compliance/navigation";
import { fetchControlDetail } from "@/features/compliance/queries";
import { ControlDetailPage } from "@/features/compliance/pages/control-detail-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/posture/compliance/controls/$catalogId",
)({
  validateSearch: (raw: Record<string, unknown>) => complianceDetailSearchSchema.parse(raw),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: ["compliance-v2", "control", context.tenant.id, params.catalogId],
      queryFn: () => fetchControlDetail(context.tenant.id, params.catalogId),
    }),
  component: ControlDetailPage,
});
